import * as ScrollLock from 'scroll-lock';

window.theme = window.theme || {};
window.theme.ScrollLock = ScrollLock;
